module.exports = __webpack_public_path__ + "static/media/survey.07d2f3e2.svg";